import React from "react";
import { HelpBody } from "./HelpKit";

/**
 * SME Help tab — renders the shared help content (HelpKit.HELP_SECTIONS), the same
 * source the slide-in help drawer uses, so the tab and the drawer never drift apart.
 */
export default function SmeHelp() {
  return (
    <div style={{ padding: "8px 4px 60px", maxWidth: 960 }}>
      <h2 style={{ fontSize: 20, margin: "4px 0 2px", fontFamily: "'Space Grotesk',system-ui,sans-serif" }}>
        SME review — how to read this workspace
      </h2>
      <p style={{ fontSize: 13.5, color: "#41474e", lineHeight: 1.55, maxWidth: 860, margin: "0 0 6px" }}>
        Every tag below also appears on the rule card and in the details panel. You don’t need to keep this
        tab open — the same reference is one tap away anywhere via the <b>?</b> icons and the floating help
        button, and it opens over whatever you’re reviewing without losing your place.
      </p>
      <HelpBody />
      <div style={{ marginTop: 22, padding: "12px 14px", background: "#f2f7f4", border: "1px solid #cfe6d8", borderRadius: 8, maxWidth: 860 }}>
        <b style={{ color: "#0a5a2f" }}>Golden rule</b>
        <p style={{ fontSize: 13.5, color: "#41474e", lineHeight: 1.55, margin: "4px 0 0" }}>
          A high violation count is only a data problem if the rule is sound. If a rule is tagged
          <b> ⚠ likely rule defect</b> or <b> ⚠ needs judgment</b>, fix or confirm the rule first — otherwise
          you’ll chase phantom data issues. When in doubt, open the details and read the sample fails and the
          reviewer’s note.
        </p>
      </div>
    </div>
  );
}
